<template>
  <section class="player-info">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8">
          <div
            class="player-content d-flex justify-content-start align-items-center"
          >
            <div class="player-jercy">
              <img
                :src="riderData?.user?.jersey"
                v-if="riderData?.user?.jersey"
              />
            </div>
            <div class="player-team-info">
              <div class="p-name">
                <img
                  class="flg"
                  width="42"
                  :src="riderData?.user?.country"
                  v-if="riderData?.user?.country"
                />
                {{
                  riderData?.user?.userData["data"]["PlayerData"][
                    "PlayerProfileStruct"
                  ]["PlayerFirstName"]
                }}
                {{
                  riderData?.user?.userData["data"]["PlayerData"][
                    "PlayerProfileStruct"
                  ]["PlayerLastName"]
                }}
              </div>
              <div class="p-team">
                TEAMS :
                <span class="catg txtClrSkyBlue">{{
                  riderData?.user?.team
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4">
          <div class="">
            <div class="editProfileWrpr">
              <div class="setBtn d-flex justify-content-end align-items-center">
                <div>
                  <router-link :to="{ name: 'profile' }" class="editBtn">
                    <i class="fa-solid fa-pen"></i> EDIT PROFILE
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-level-div">
        <div class="row d-flex align-items-center">
          <div class="col-md-6">
            <div class="catBtnWrpr">
              <span class="gen txtClr">
                {{
                  genders[
                    riderData?.user?.userData["data"]["PlayerData"][
                      "PlayerProfileStruct"
                    ]["Gender"]
                  ]
                }}
              </span>
              <span
                class="cat-list bgClrRed"
                v-if="
                  riderData?.user?.userData['data']['PlayerData'][
                    'PlayerProfileStruct'
                  ]['PlayerCategoryId']
                "
              >
                CAT
                {{
                  riderData?.user?.userData["data"]["PlayerData"][
                    "PlayerProfileStruct"
                  ]["PlayerCategoryId"]
                }}
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="player-skills d-flex justify-content-between align-items-end"
            >
              <div class="">
                <p class="title">LEVEL</p>
                <div>
                  <span class="num-count txtClrOrg">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerPersonalStruct"
                      ]["PlayerLevel"]
                    }}
                  </span>
                </div>
              </div>
              <div class="">
                <p class="title">FTP</p>
                <div>
                  <span class="num-count">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerPersonalStruct"
                      ]["PlayerFtp"]
                    }}
                    W
                  </span>
                </div>
              </div>
              <div
                class=""
                v-if="
                  riderData?.user?.userData['data']['PlayerData'][
                    'PlayerPersonalStruct'
                  ]['VerifiedWeight']
                "
              >
                <p class="title">
                  WEIGHT <img src="/assets/images/activities/icn_check.png" />
                </p>
                <div>
                  <span class="num-count">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerPersonalStruct"
                      ]["VerifiedWeight"]
                    }}
                    KG
                  </span>
                </div>
              </div>
              <div class="" v-else>
                <p class="title">WEIGHT</p>
                <div>
                  <span class="num-count">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerProfileStruct"
                      ]["Weight"]
                    }}
                    KG
                  </span>
                </div>
              </div>
              <div
                class=""
                v-if="
                  riderData?.user?.userData['data']['PlayerData'][
                    'PlayerPersonalStruct'
                  ]['VerifiedHeight']
                "
              >
                <p class="title">
                  HEIGHT <img src="/assets/images/activities/icn_check.png" />
                </p>
                <div>
                  <span class="num-count">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerPersonalStruct"
                      ]["VerifiedHeight"]
                    }}
                    CM
                  </span>
                </div>
              </div>
              <div class="" v-else>
                <p class="title">HEIGHT</p>
                <div>
                  <span class="num-count">
                    {{
                      riderData?.user?.userData["data"]["PlayerData"][
                        "PlayerProfileStruct"
                      ]["HeightCm"]
                    }}
                    CM
                  </span>
                </div>
              </div>
              <div class="" v-if="riderData?.user?.age">
                <p class="title">AGE</p>
                <div>
                  <span class="num-count">{{ riderData?.user?.age }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PlayerInfo",
  props: {
    riderData: {
      type: Object,
      default: () => ({}),
    },
    genders: {
      type: Array,
      default: () => ["MEN", "FEMALE", "Both"],
    },
  },
};
</script>
